"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiStepLabelStyles = exports.stepTitleTextColor = void 0;
var component_2023_utils_token_parser_1 = require("@rentspree/component-2023.utils.token-parser");
exports.stepTitleTextColor = (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-text.color');
exports.muiStepLabelStyles = {
    styleOverrides: {
        root: {
            height: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-container.height'),
            borderRadius: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-container.shape'),
            padding: "".concat((0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-container.padding'), " !important"),
            flexDirection: 'row !important',
            margin: '0 !important',
            width: 'fit-content',
            '&.RSPStepLabel-active': {
                backgroundColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.active.text-container.color'),
                boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.02)',
            },
        },
        labelContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            textAlign: 'start !important',
        },
        label: {
            fontFamily: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-text.font'),
            fontWeight: "".concat((0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-text.weight'), " !important"),
            fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-text.size'),
            letterSpacing: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-text.letter-spacing'),
            lineHeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.title-text.line-height'),
            color: exports.stepTitleTextColor,
            textAlign: 'start',
            width: 'max-content',
            '&.MuiStepLabel-alternativeLabel': {
                marginTop: 0,
            },
            '&.Mui-active': {
                color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.active.title-text.color'),
            },
            '&.Mui-completed': {
                color: exports.stepTitleTextColor,
            },
        },
        iconContainer: {
            color: 'rgba(26, 150, 47, 1)',
            '& .MuiSvgIcon-root': {
                height: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.icon.size'),
                width: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.step-item.icon.size'),
            },
        },
        vertical: {
            width: '100%',
        },
    },
};
//# sourceMappingURL=step-label.js.map